import styled from 'styled-components';

export const clsPrefix = 'ui-calendar-header';

export const CalendarHeaderSC = styled.header`
  height: 56px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};

  .${clsPrefix}__title {
    flex: 1;

    padding: 0 16px;

    text-align: center;
    color: ${({ theme }) => theme.color.tint.primary};
    ${({ theme }) => theme.mappedTypography.h6.default};
  }

  .${clsPrefix}__left, .${clsPrefix}__right {
    min-width: 32px;
  }
`;
